module.exports = __webpack_public_path__ + "img/bank-config.013ab38e.svg";